export enum PaginationTheme {
    Light = 'Light',
    Navy = 'Navy',
}
